export default function isOwner(role = []) {
  return role.includes('owner');
}
